export default {
  path: ":alias/treeWishes",
  component: resolve => require(["@/views/tree-wishes"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/tree-wishes/list"], resolve)
    }
  ]
};
